module.exports = __webpack_public_path__ + "static/media/2Circle.163c5399.svg";